import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { SlicePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { KeysPipe } from "../../../../helpers/keyspipe/keyspipe";
import { StatusToIconPipe } from "../../../../helpers/statusiconpipe/statusiconpipe";

const STATUS_KEYS: Record<string, string> = {
  ok: "Services.Status.Ok",
  notfound: "Services.Status.NotFound",
  notraffic: "Services.Status.NoTraffic",
  pending: "Services.Status.Pending",
  initial: "Services.Status.Initial",
  stopped: "Services.Status.Stopped",
  unknown: "Services.Status.Unknown",
  malfunction: "Services.Status.Warning",
  critical: "Services.Status.Critical",
  high: "Services.Status.High",
  medium: "Services.Status.Medium",
};

@Component({
  selector: "health-indicators",
  templateUrl: "health-indicators.html",
  styleUrls: ["../service-tile.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KeysPipe, SlicePipe, StatusToIconPipe, AngularSvgIconModule, MatTooltipModule, TranslatePipe],
})
export class HealthIndicators {
  protected indicators = input<Map<string, number>>(new Map());
  protected colors: { [key: string]: string } = {
    ok: "green",
    notfound: "orange",
    notraffic: "grey",
    pending: "orange",
    initial: "orange",
    stopped: "red",
    unknown: "grey",
    malfunction: "grey",
    critical: "red",
    high: "orange",
    medium: "yellow",
  };

  protected statusKey(state: string): string {
    return STATUS_KEYS[state] ?? "Services.Status.Unknown";
  }
}
